import React from 'react';
import PropTypes from 'prop-types';

class SearchInput extends React.Component {
    render(){
        return (
            <div className="search icon input">
                <i className="search icon"></i>
                <input type="text" placeholder={ this.props.placeholderText } tabIndex="0" />
            </div>
        );
    }
}

SearchInput.propTypes = {
    placeholderText: PropTypes.string
};

SearchInput.defaultProps = {
    placeholderText: 'Search...'
};

export default SearchInput;
